import React, { useEffect, useState } from "react";
import { getCurrentUser, getHostDetails, getLoggedUserDetails, getLoginLogoutUserStatus, getloginupdatedstatus, getLogoutUserStatus, getUserProfilePic, loadUserDetails, loadUserProfilePic, loginLogoutStatusReceived, loginLogoutUpdateStatus, loginStatusUpdate, logoutCurrentUser, userLogoutStatusRecevied } from "../../store/auth";
import ChangePassword from "../../../components/ChangePassword";
import Help from "../../../components/Anlytics/Help";
import SupportPupup from "../../../components/Anlytics/SupportPupup";
import { useDispatch, useSelector } from "react-redux";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../../store/layoutUI";
import AddSecurityQuestion from "../../../components/AddSecurityQuestion";
import PartnerProfile from "../../../components/PartnerManage/PartnerProfile";
import config from "../../../config.json";
import { PUBLIC_CLIENT_APPLICATION } from "../../../msalConfig";

const TopMenu = () => {

    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [helpDocs, setHelpDocs] = useState(null);
    const [logoutProccess, setLogoutProccess] = useState(false);

    const pageTitleSelector = useSelector(getPageTitle);
    const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
    const userProfilePicSelector = useSelector(getUserProfilePic);
    const userLoginSelector = useSelector(getloginupdatedstatus);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const hostDetailsSelector = useSelector(getHostDetails)
    const logoutUserStatusSelector = useSelector(getLogoutUserStatus)
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus)
    //const userDetailsSelectors = useSelector(getLoggedUserDetails)

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (currentUser?.id) {
            dispatch(loadUserDetails(currentUser.id));
            dispatch(loadUserProfilePic(currentUser.id));
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.adminDoc))
        }
    }, []);

    useEffect(() => {
        console.log("Workbench help docs selector updated:", workbenchHelpDocsSelector);
        if (workbenchHelpDocsSelector) {
            //const url = URL.createObjectURL(workbenchHelpDocsSelector);
            setHelpDocs(workbenchHelpDocsSelector)
        }

    }, [workbenchHelpDocsSelector])



    useEffect(() => {
        if (loggedUserDetailsSelector)
            if (loggedUserDetailsSelector?.maxtasks === null) {
                dispatch(loginStatusUpdate(currentUser.id))
                setFirstLogin(true)
                setSecurityShowHide(!securityShowHide);
            } else {
                setFirstLogin(false)
            }

        setUserDetails(loggedUserDetailsSelector)
    }, [loggedUserDetailsSelector]);

    useEffect(() => {
        if (userProfilePicSelector) {
            //let objectURL = 'data:image/jpeg;base64,' + userProfilePicSelector;
            setProfilePicData(userProfilePicSelector);
        }

    }, [userProfilePicSelector])

    let usrType = localStorage.getItem("userType");

    const handleModalShowHide = () => {
        setShowHide(!showHide);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide(!helpShowHide);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide(!issueShowHide);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide(!securityShowHide);
    };

    const handleCurrentTask = async (wiid) => {
        // const { data: workflowTask } = await http.get(
        //   config.GetWorkflowTask + wiid
        // );
        // if (workflowTask.formId > 0) {
        //   if (workflowTask.formType === "CF") {
        //     this.props.history.push({
        //       pathname: "/" + workflowTask.formName,
        //       state: { workflowTask },
        //     });
        //   } else {
        //     this.props.history.push({
        //       pathname: "/DynamicHtmlForm",
        //       state: { workflowTask },
        //     });
        //   }
        // }
    };

    const handleWorkflowTask = (data) => {
        // this.props.history.push({
        //   pathname: "/DynamicHtmlForm",
        //   state: { workflowTask: data },
        // });
    };

    const handleProfileShowHide = () => {
        setProfileShowHide(!profileShowHide);
        dispatch(loadUserDetails(currentUser.id));
    };

    const handleLogout = async () => {
        setLogoutProccess(true);
        const hostId = localStorage.getItem("hostId");
        localStorage.removeItem("token")
        if (hostId && currentUser?.id) {
            dispatch(logoutCurrentUser(currentUser.id, hostId));
        } else {
            await PUBLIC_CLIENT_APPLICATION.logoutPopup();
            window.location = "/login";
        }

        localStorage.clear();
        sessionStorage.clear();

        if (currentUser?.id)
            dispatch(loginLogoutUpdateStatus(currentUser.id));


    }

    useEffect(() => {
        setLogoutProccess(false);
        if (logoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false))
            window.location = "/login";
        }
        if (loginLogoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false))
            window.location = "/login";
        }
    }, [logoutUserStatusSelector, loginLogoutUserStatusSelector])

    let $imagePreview = null;
    $imagePreview = <img
        alt="profile" className="img-thumbnail rounded-circle" style={{ height: "60px", width: "60px" }}
        src={`${!profilePicData ? "../../assets/img/theme/team-4.png" : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData}`}
    />

    return <>
        <div className="row">
            <div
                className="col-md-8 p-2"
            >
                <img
                    src={`/assets/Img/logo.png`}
                    alt="International Project Consultancy Services (IPCS), Inc."
                    style={{
                        height: "80px",
                    }}
                />
            </div>
            <div className="col-md-4 p-2 d-flex justify-content-end">
                <nav className="navbar navbar-top navbar-expand navbar-dark p-0">
                    <div className="collapse navbar-collapse"
                        id="navbarSupportedContent"
                    >

                        <ul className="navbar-nav align-items-center ml-auto ml-md-0">
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link pr-0"
                                    href="#"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <div className="media align-items-center">
                                        {$imagePreview}
                                        {currentUser && <div className="media-body ml-2 d-none d-lg-block">
                                            <span className="mb-0 text-sm font-weight-bold text-dark text-uppercase">
                                                <b>{currentUser.name}</b>
                                            </span>
                                            <h5 className="text-dark">
                                                Reg ID :{" "}
                                                {currentUser.type === "partner"
                                                    ? currentUser.linkUser
                                                    : currentUser.id}

                                                {currentUser.type === "partner" &&
                                                    `"Partner ID :" ${currentUser.id} `}
                                                <br />
                                                Role :{" "}
                                                <span className="text-capitalize">
                                                    {/* {usrType === "WP" || currentUser.type === "WP" ? "Workflow Performer" : usrType} */}
                                                    {currentUser?.type === "admin" ? "Super Admin" : userDetails?.role}
                                                </span>
                                                <br />
                                                Last Login : {(new Date()).toDateString()}
                                            </h5>
                                        </div>}
                                    </div>
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <button className="dropdown-item"
                                        onClick={handleProfileShowHide}
                                    >
                                        <i className="ni ni-single-02" />
                                        <span>My Profile</span>
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={handleModalShowHide}
                                    >
                                        <i className="ni ni-settings-gear-65" />
                                        <span>Change Password</span>
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={handleSecurityShowHide}
                                    >
                                        <i className="fa fa-shield" />
                                        <span>Change Security Questions</span>
                                    </button>
                                    {/* <button
                                        className="dropdown-item"
                                        onClick={handleHelpShowHide}
                                    >
                                        <i className="ni ni-support-16" />
                                        <span>Help</span>
                                    </button> */}

                                    <div className="dropdown-divider" />
                                    <button onClick={handleLogout} className="dropdown-item">
                                        <i className="ni ni-user-run" />
                                        <span>Logout</span>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
        <div className="row border pt-2 pb-2">
            <div className="col-md-5">
                <img
                    src="/assets/img/wflogoblack.png"
                    alt="Workfinity"
                    className="navbar-brand-img"
                    style={{ height: "28px" }}
                />
                <button className="btn btn-sm btn-outline-default text-capitalize">
                    Workbench Portal
                </button>
            </div>
            <div className="col-md-1 text-center">
                {/* <span className="h3 text-dark">
                    HUMAN RESOURCES ONBOARDING, CONTRACT AND INVOICING SYSTEM
                </span> */}
            </div>
            <div className="col-md-6 text-right">
                <button
                    onClick={handleIssueShowHide}
                    className="btn btn-sm btn-outline-default mr-2"

                    title="Any defects/issues found in the Portal can be registered in the Customer Support Portal."
                >
                    <i className="fa fa-support"></i> Customer Support
                </button>
                <button
                    className="btn btn-sm btn-outline-default mr-2"
                    // style={{ minWidth: "8.56rem" }}
                    onClick={handleHelpShowHide}
                >
                    <i className="fa fa-question-circle"></i> Help
                </button>
                <button
                    className="btn btn-sm btn-outline-default m-0"
                    // style={{ minWidth: "8.56rem" }}
                    onClick={handleLogout}
                >
                    <i className="ni ni-user-run" /> Logout
                </button>
            </div>
        </div>
        <div className="row border-bottom pb-1">
            <div className="col-12 text-center">
                <span className="h2 text-dark">
                    NEXT GENERATION HUMAN RESOURCE ONBOARDING, CONTRACT, TIME LOG AND INVOICING SYSTEM
                </span>
            </div>
        </div>
        {showHide &&
            <ChangePassword
                handleModalShowHide={handleModalShowHide}
                showHide={showHide}
            ></ChangePassword>}
        {profileShowHide &&
            <PartnerProfile
                handleProfileShowHide={handleProfileShowHide}
                profileShowHide={profileShowHide}
            ></PartnerProfile>}
        {helpShowHide &&
            <Help
                helpShowHide={helpShowHide}
                handleHelpShowHide={handleHelpShowHide}
                module={pageTitleSelector}
                helpDocs={helpDocs}
            ></Help>}
        {issueShowHide &&
            <SupportPupup
                handleIssueShowHide={handleIssueShowHide}
                issueShowHide={issueShowHide}
                handleCurrentTask={handleCurrentTask}
                handleWorkflowTask={handleWorkflowTask}
            ></SupportPupup>}

        {securityShowHide && <AddSecurityQuestion
            firstLogin={firstLogin}
            securityShowHide={securityShowHide}
            handleSecurityShowHide={handleSecurityShowHide}
            userDetails={userDetails}
            handleLogout={handleLogout}
        ></AddSecurityQuestion>}
    </>
}

export default TopMenu;